<!-- 头部 -->
<template>
    <div class="navbar-content display-y-center display-s-b">
        <div class="bar display-x-end display-y-center display-column"
            v-for="(item, index) in navbarList"
            :class="index==state.navbarIndex?'active':''"
            @click="onLink(item, index)">
            <div :class="{blackBg: index == 2}">
                <div class="img-div" :class="{special: index == 2}">
                    <img :src="index==state.navbarIndex?item.iconActive:item.icon" />
                </div>
            </div>
            <span>{{ item.text }}</span>
        </div>
    </div>
</template>
  
<script setup lang="ts">
import { onBeforeMount, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { navbarList } from '@/views/home/dataConfig';
import { getSessionData, setSessionData } from '@/handle/sessionHandle';
import { SESSION_STORE } from '@/config/constConfig';
import { freshBalance } from '@/handle/balanceHandle';

const router = useRouter();

let state = reactive({
    navbarIndex: 0 as number
});

onBeforeMount(() => {
    initIndex();
    getIndex();
});

function initIndex() {
    if (router.currentRoute.value.path == "/") {
        setSessionData(SESSION_STORE.NAVBAR_INDEX.key, 0);
    }
}

function getIndex(): number {
    let index = getSessionData(SESSION_STORE.NAVBAR_INDEX.key);
    if (index) {
        state.navbarIndex = index;
    }
    return state.navbarIndex;
}

function onLink(item: any, index: number) {
    if (index == 0) {
        freshBalance();
    }
    state.navbarIndex = index;
    setSessionData(SESSION_STORE.NAVBAR_INDEX.key, index);
    router.push(item.path);
}

</script>

<style lang="less" scoped>
.navbar-content {
    width: 100%;
    max-width: @max-width;
    height: @navbar-height;
    background-color: #111111;
    position: absolute;
    bottom: 0;
    z-index: 100;
    .bar {
        height: 100%;
        flex: 1;
        color: #878E94;
        margin-top: -30rem;
        .img-div{
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            >img {
                width: 25rem;
                font-size: 12rem;
            }
        }
        .blackBg{
            padding: 5rem;
            border-radius: 50%;
            background: #0F1D29;
        }
        .special{
            background: linear-gradient(90deg, #FF8311 0%, rgba(255, 214, 69, 0.992157) 100%);
            border-radius: 50%;
            width: 40rem;
            height: 40rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        >span {
            margin-top: 5rem;
        }
        &.active {
            color: #FFD645;
        }
    }
}
</style>